import { formatWithValidation } from 'next/dist/shared/lib/router/utils/format-url'
import { interpolateAs } from 'next/dist/shared/lib/router/utils/interpolate-as'
import { omit } from 'next/dist/shared/lib/router/utils/omit'
import { useRouter } from 'next/router'
import { ComponentProps, useCallback } from 'react'
import { Pagination } from '~/components/modules/Pagination/Pagination'

const prod = process.env.NODE_ENV !== 'development'

export const usePaginationProps = (
  currentPage: number,
  totalPage: number,
  spPrefix: boolean
): ComponentProps<typeof Pagination> => {
  const { query, pathname } = useRouter()
  const buildUrl = useCallback(
    (page: number) => {
      if (page < 1 || totalPage < page) return undefined
      // HACK: /[username]/favorite/[folderId]/ から /wearofficial/favorite/1111/?pageno=2 などのURLを組み立てる
      // resolveHref関数の簡易実装
      // ref. https://github.com/vercel/next.js/blob/4c723f4d66feaff2b5dd7ea8d079409675573357/packages/next/src/shared/lib/router/utils/resolve-href.ts#L26
      const newQuery: Record<string, string | undefined> = {
        ...query,
        pageno: page.toString(),
      }
      const { result, params } = interpolateAs(pathname, pathname, newQuery)
      const pathWithTrailingSlash = `${result}/`.replace(/\/+$/g, '/')
      const href = formatWithValidation({
        pathname: pathWithTrailingSlash,
        query: omit(newQuery, page === 1 ? [...params, 'pageno'] : params),
      })
      return spPrefix && prod ? `/sp${href}` : href
    },
    [pathname, query, spPrefix, totalPage]
  )
  return { currentPage, totalPage, buildUrl }
}
